<template>
  <div class="weikeson-warp">
    <router-view></router-view>
    <!-- 内容 -->
    <div class="weikeson-content">
      <!-- 课程 -->
      <div class="weikeson-kelist">
        <div class="weikeson-kelist-nr">
          <div class="weikeson-kelist-nr-leftimg">
            <img :src="'http://ke.yunlearning.com' + zpall.cover_img" alt="###" />
          </div>
          <div class="weikeson-kelist-nr-r">
            <div class="weikeson-kelist-nr-r-t">
              <p class="weikeson-kelist-nr-r-p1">{{ zpall.title }}</p>
              <div class="wk-cont-s">
                <div class="wk-cont-sleft">
                  <i class="weikeson-icon-love"></i>
                  <span>课程票数：{{ zpall.praise }}票</span>
                </div>
                <div class="wk-cont-sright">
                  <span>上传时间：</span>
                  <span class="weiketime">{{ wkstime }}</span>
                </div>
              </div>

              <p class="weikeson-kelist-nr-r-txt">
                {{ zpall.message }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="weikeson-plall">
        <!-- 评论 -->
        <div class="weikeson-pl">
          <!-- 评论 -->
          <div class="wl-pl-left">
            <div class="wk-pl-title">
              <p>课程评论（{{total}}）</p>
            </div>
            <div class="wk-pl-xian"></div>
            <!-- 评论内容 -->
            <div class="wk-pl-inp">
              <div class="wk-pl-inp-txt">
                <el-input
                  v-model="wkpl"
                  placeholder="请输入您的评价"
                ></el-input>
              </div>
              <div @click="btnping" class="wk-pl-btn">
                <span>提交评价</span>
              </div>
            </div>
            <!-- 评论区 -->
            <div
              v-for="(item, index) in commentdata"
              :key="item.id"
              class="wk-pl-txt"
            >
              <div class="wk-pl-cont">
                <!-- 个人头像 -->
                <div class="wk-pl-logotxt">
                  <div class="wk-pl-icon">
                    <img :src="'http://ke.yunlearning.com:8081'+commentdata[index].user.head_img" alt="###" />
                  </div>
                  <!-- 内容介绍 -->
                  <div class="wk-pl-nr">
                    <p>{{ commentdata[index].user.nickname }}</p>

                    <p>
                      {{ commentdata[index].comment }}
                    </p>
                    <!-- 时间 -->
                    <div class="wk-pl-time">
                      <span>{{
                       
                        new Date(commentdata[index].create_time *1000).toLocaleString().replace(/:\d{1,2}$/,' ')
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <div class="wk-pl-pagin">
              <el-pagination
                background
                layout="prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentpage"
                :total="total"
                :page-size="perpg"
              >
              </el-pagination>
            </div>
          </div>

          <!-- N人观看此课程 -->
          <div class="wk-pl-right">
            <!-- 上部分 -->
            <div class="wk-pl-top">
              <div class="wk-pl-look">
                <p>已有{{liuimg.length}}人次观看了此课程</p>
              </div>
              <div class="wk-pl-imglogo">
                <img
                  v-for="(item,index) in liuimg"
                  :key="item.id"
                  :src="'http://ke.yunlearning.com:8081'+liuimg[index]"
                  alt="###"
                />
              </div>
            </div>
            <!-- 同类课程推荐 -->
            <div class="wk-pl-tonglei">
              <!-- 标题 -->
              <div class="wk-pl-tl-title">
                <p>同类课程</p>
              </div>
              <!-- 课程推荐 -->
              <div class="wk-pl-kes">
                <div class="wk-pl-kes-flex">
                  <div
                    v-for="(item,index) in similar"
                    :key="item.id"
                    class="wk-pl-kes-nr"
                    @click="wksmiilar(index)"
                  >
                    <img :src="'http://ke.yunlearning.com:8081'+similar[index].cover_img" alt="" />
                    <p>{{ similar[index].title }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <botTom></botTom>
  </div>
</template>

<script>
import botTom from "./BotTom";
import weikeson from "../css/weikeson.css";
import axios from "axios";
export default {
  data() {
    return {
      wkpl: "", //Ping评论内容
      plnr: [1],
      rightlogo: [
        {
          url: "../../static/wkplicona.png",
        },
        {
          url: "../../static/wkpliconb.png",
        },
        {
          url: "../../static/wkplicona.png",
        },
        {
          url: "../../static/wkpliconc.png",
        },
        {
          url: "../../static/wkplicond.png",
        },
        {
          url: "../../static/wkplicone.png",
        },
        {
          url: "../../static/wkpliconf.png",
        },
        {
          url: "../../static/wkplicong.png",
        },
        {
          url: "../../static/wkpliconh.png",
        },
      ],
      kelei: [
        { leiurl: "../../static/wkleia.png", leititle: "连续梁桥的施工" },
        { leiurl: "../../static/wkleib.png", leititle: "连续梁桥的施工" },
        { leiurl: "../../static/wkleia.png", leititle: "连续梁桥的施工" },
        { leiurl: "../../static/wkleib.png", leititle: "连续梁桥的施工" },
      ],
      commentdata: [], //评论数据
      currentpage: 1, //当前页数
      perpg: 3, //一页显示的数据数
      total: 5, //总数据
      zpall: [],
      wkstime: "",//时间
      similar:[],//同类课程
      liunum:[], //浏览数和logo
      liuimg:[],//logo
    }
  },
  methods: {
    handleSizeChange(val) {
      this.perpg = val;
      // console.log(this.perpg, "一页显示的数据");
    },

    btnping() {
      //提交评论，ID，token
      let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
      let id = JSON.parse(sessionStorage.getItem("id"));
      let plun = this.wkpl;
      let fa = new window.FormData();
      fa.append("token", tokens);
      fa.append("id", id);
      fa.append("comment", plun);
      
      if (this.wkpl == "") {
        this.$message.error({
          message:"评论为空！请输入内容",
          offset:200
        });
      } else {
        this.$message({
          message:"评论成功！",
          offset:200,
          type:'success'
        });
        axios({
          method: "post",
          url: this.$apiUrl + "/index.php/user/comment",
          data: fa,
        })
          .then((res) => {
          
          })
          .catch((error) => {});
        this.wkpl = "";
      }
    },
    //评论展示
    comment_nr() {
      let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
      let id = JSON.parse(sessionStorage.getItem("id"));
      let fas = new window.FormData();
      fas.append("id", id);
      fas.append("token", tokens);
      fas.append('page',this.currentpage);
      axios({
        method: "post",
        url: this.$apiUrl + "/index.php/user/comment_list",
        data: fas,
      })
        .then((res) => {
          this.commentdata = res.data.data.data;
          this.perpg = res.data.data.per_page;//一页显示的数据
          this.total = res.data.data.total; //总数据数
        })
        .catch((error) => {});
    },
    //分页
    handleCurrentChange(val) {
      this.currentpage = val;
      this.comment_nr();
   
    },
          // 时间
 timestampToTime(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var  Y = date.getFullYear() + '';
  var   M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var   D = this.change(date.getDate()) + '';
  var   h = this.change(date.getHours()) + ':';
  var   m = this.change(date.getMinutes()) + ':';
  var   s = this.change(date.getSeconds());
    return Y+'-'+M+'-'+D;
},
change(t) {
    if (t < 10) {
        return "0" + t;
    } else {
        return t;
    }
 
},
    // 作品信息展示
    zpxinxiAll() {
      this.zpall = JSON.parse(sessionStorage.getItem('zpdataAll'));
      // this.wkstime = new Date(this.zpall.create_time *1000)
      //   .toLocaleString()
      //   .replace(/:\d{1,2}$/,' ')
      //   .substring(0, 10);
          var t=this.zpall.create_time;
this.wkstime = this.timestampToTime(t);
    },
    //同类课程推荐
    similars(){
      let fas = new window.FormData;
      fas.append('type_id',this.zpall.type_id);
      axios({
        method:'post',
        url:this.$apiUrl+'/index.php/course/index?limit=4',
        data:fas
      }).then(res =>{
       
        this.similar = res.data.data.data;
        //  console.log(this.similar,'wksss')
      })
    },
    //同类课程点击进入该作品详情
    wksmiilar(index){
      this.$store.commit('zuopbtnId',this.similar[index].id);
      this.$router.push({path:'/ptson'});
    },
    // 课程的浏览量和头像
    wklooknum(){
      let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
      let id = JSON.parse(sessionStorage.getItem("id"));
      let fass = new window.FormData;
      fass.append('token',tokens);
      fass.append('id',id);
      axios({
        method:'post',
        url:this.$apiUrl+'/index.php/course/browse',
        data:fass
      }).then(res =>{
       this.liunum = res.data.msg;
      for (let index = 0; index < this.liunum.length; index++) {
       if (this.liunum[index].user !==null) {
          this.liuimg.push(this.liunum[index].user.head_img);
       }
        
      }

    
      })
    }
  },
  components: {
    botTom,
  },
  mounted() {
    this.comment_nr();
    this.zpxinxiAll();
    this.similars();
    this.wklooknum();
  },
  computed: {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/WeiKeson.vue